angular.module('unica_survey.survey_controllers')

.controller('SurveyCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	SurveyCreateService
) {

	$scope.pageTitle = 'Aggiungi Survey';

	$rootScope.surveyData = {
		event_id: $stateParams.event_id
	};

	$scope.saveSurvey = function() {
		$scope.showLoader();

		var surveyData = angular.copy($rootScope.surveyData);
		surveyData.event_id = $stateParams.event_id;

		// console.log( surveyData );return;

		SurveyCreateService
			.create(surveyData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Survey aggiunto con successo!', '');
					$rootScope.surveyData = {};
					$state.go('app.survey.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});

	};

})

;
